// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".import-paragraph[data-v-28948606]{margin:.5rem}.import-watch-data[data-v-28948606]{margin:1rem}.import-field .p-dropdown[data-v-28948606]{width:90%}.import-field .p-inputtext[data-v-28948606]{width:95%}.import-field[data-v-28948606]{margin:.5rem}.import-content-div[data-v-28948606]{margin:1rem 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
